// extracted by mini-css-extract-plugin
module.exports = {"holder":"HorizontalNavigationItems_holder__FdCaR"};